/* eslint-disable */
const state = () => ({
  showNavbar: true,
  prevRoute: null,
});

const getters = {
  getNavbarstatus(state: { showNavbar: boolean }) {
    return state.showNavbar;
  },
  getPrevRoute(state: { prevRoute: string | null }) {
    return state.prevRoute;
  },
};

const actions = {
  setNavbar({ commit }: any, data: boolean) {
    commit("setNavbar", data);
  },
  setPrevRoute({ commit }: any, data: string | null) {
    commit("setPrevRoute", data);
  },
};

const mutations = {
  setNavbar(state: { showNavbar: boolean }, data: boolean) {
    state.showNavbar = data;
  },
  setPrevRoute(state: { prevRoute: string | null }, data: string | null) {
    state.prevRoute = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
